export interface DgAdditionalFilters {
  includeCeased : boolean;
  includeDeleted: boolean;
  onlyCeased    : boolean;
  onlyDeleted   : boolean;
}

export function DgAdditionalFilters_EmptyObject(): DgAdditionalFilters {
  return {
    includeCeased : false,
    includeDeleted: false,
    onlyCeased    : false,
    onlyDeleted   : false
  };
}

export function DgAdditionalFilters_FetchCeased(filters: DgAdditionalFilters | undefined): boolean {
  return filters?.includeCeased===true || filters?.onlyCeased===true;
}

export function DgAdditionalFilters_FetchDeleted(filters: DgAdditionalFilters | undefined): boolean {
  return filters?.includeDeleted===true || filters?.onlyDeleted===true;
}
